import React from "react";
import { Box, List, ListItem, Skeleton } from "@mui/material";
import { TabPanel } from "./TabPanel";

export function DocumentsSkeletonPanel({ tabIndex }: { tabIndex: number }) {
  return (
    <TabPanel value={tabIndex} index={tabIndex}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          mb: 2,
          bgcolor: "#fff3cf",
          borderRadius: "8px",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="80%" height={20} />
        </Box>
        <Skeleton
          variant="rectangular"
          width={200}
          height={32}
          sx={{ borderRadius: 1 }}
        />
      </Box>

      <Skeleton
        variant="text"
        width="40%"
        height={28}
        sx={{ mt: 3, mb: 1 }}
      />

      <List sx={{ p: 0 }}>
        {[1, 2].map((item) => (
          <ListItem
            key={item}
            sx={{
              mb: 1,
              bgcolor: "#fff",
              border: "1px solid #eee",
              borderRadius: "8px",
              py: 1.5,
              px: 2,
              display: "flex",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                flex: "1 1 auto",
                minWidth: "180px",
                pr: 2,
              }}
            >
              <Skeleton
                variant="text"
                width={item === 1 ? "40%" : "45%"}
                height={20}
                sx={{ mb: 0.5 }}
              />
              <Skeleton
                variant="text"
                width={item === 1 ? "70%" : "75%"}
                height={20}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
                width: { xs: "100%", sm: "auto" },
                mt: { xs: 1, sm: 0 },
                flexWrap: "nowrap",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={70}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />
              <Skeleton
                variant="rectangular"
                width={80}
                height={32}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={item === 1 ? 100 : 120}
                height={32}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </ListItem>
        ))}
      </List>

      <Skeleton
        variant="rectangular"
        width={120}
        height={40}
        sx={{ mt: 2, borderRadius: 1 }}
      />

      <Skeleton
        variant="text"
        width="35%"
        height={28}
        sx={{ mt: 3, mb: 1 }}
      />

      <List sx={{ p: 0 }}>
        <ListItem
          sx={{
            mb: 1,
            bgcolor: "#fff",
            border: "1px solid #eee",
            borderRadius: "8px",
            py: 1.5,
            px: 2,
            display: "flex",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              flex: "1 1 auto",
              minWidth: "180px",
              pr: 2,
            }}
          >
            <Skeleton variant="text" width="35%" height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="60%" height={20} />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
              width: "auto",
              mt: { xs: 1, sm: 0 },
            }}
          >
            <Skeleton
              variant="rectangular"
              width={70}
              height={24}
              sx={{ borderRadius: 0.5 }}
            />
            <Skeleton
              variant="rectangular"
              width={60}
              height={32}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </ListItem>
      </List>
    </TabPanel>
  );
}

